import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'viewableExtension',
})
export class ViewableExtensionPipe implements PipeTransform {
  transform(value: any): any {
    let stringSplit = [],
      newString: string;

    if (value.includes(';')) {
      stringSplit = value.split(';');
      newString = `${stringSplit[0]} ext ${stringSplit[1]}`;
    } else {
      return value;
    }

    return newString;
  }
}
